import script from "./SceneEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./SceneEditor.vue?vue&type=script&setup=true&lang=ts"

import "./SceneEditor.vue?vue&type=style&index=0&id=b6fdd656&lang=css"

const __exports__ = script;

export default __exports__